import { Link, Navigate, useParams } from "react-router-dom";
import { ArrowLeft, ArrowUpRight, Check } from "lucide-react";
import { SETTORI } from "@/data/content";

export default function SettoreDetail() {
  const { slug } = useParams();
  const settore = SETTORI.find((s) => s.slug === slug);
  if (!settore) return <Navigate to="/settori" replace />;

  const idx = SETTORI.findIndex((s) => s.slug === slug);
  const next = SETTORI[(idx + 1) % SETTORI.length];

  return (
    <div data-testid={`page-settore-${slug}`} className="pt-28">
      <section className="container-x py-12">
        <Link to="/settori" className="inline-flex items-center gap-2 text-sm text-muted-foreground underline-link" data-testid="settore-back">
          <ArrowLeft className="h-4 w-4" /> Tutti i settori
        </Link>
      </section>

      <section className="container-x grid md:grid-cols-12 gap-10 pb-16">
        <div className="md:col-span-4">
          <span className="overline">Settore {String(idx + 1).padStart(2, "0")}</span>
          <p className="mt-3 font-display text-7xl text-primary/20 leading-none">0{idx + 1}</p>
        </div>
        <div className="md:col-span-8">
          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl leading-[1.04] tracking-tight">{settore.title}</h1>
          <p className="mt-6 text-xl text-primary font-medium">{settore.short}</p>
          <p className="mt-6 text-lg text-muted-foreground leading-relaxed max-w-2xl">{settore.body}</p>
        </div>
      </section>

      {settore.image && (
        <section className="container-x pb-4">
          <div className="relative aspect-[21/9] w-full overflow-hidden">
            <img
              src={settore.image}
              alt={settore.title}
              className="absolute inset-0 h-full w-full object-cover"
              data-testid={`settore-hero-image-${slug}`}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0A1F2E]/25 via-transparent to-transparent" />
          </div>
        </section>
      )}

      <section className="bg-[#0A1F2E] text-white section-y">
        <div className="container-x grid md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <span className="overline text-[#89E877]">Coperture</span>
            <h2 className="mt-4 font-display text-4xl sm:text-5xl">Cosa progettiamo per te</h2>
          </div>
          <ul className="md:col-span-8 space-y-5">
            {settore.coperture.map((c) => (
              <li key={c} className="flex items-start gap-4 border-b border-white/10 pb-5">
                <Check className="h-5 w-5 mt-1 text-[#89E877] shrink-0" />
                <span className="text-lg">{c}</span>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="container-x section-y grid md:grid-cols-12 gap-10 items-end">
        <div className="md:col-span-7">
          <span className="overline">Continua</span>
          <Link
            to={`/settori/${next.slug}`}
            className="mt-4 block font-display text-5xl sm:text-6xl leading-[1.05] underline-link"
            data-testid={`next-settore-${next.slug}`}
          >
            {next.title} <ArrowUpRight className="inline h-8 w-8" />
          </Link>
          <p className="mt-3 text-muted-foreground">{next.short}</p>
        </div>
        <div className="md:col-span-5 md:justify-self-end">
          <Link to="/contatti" data-testid="settore-cta-contatti" className="btn-primary">
            Parla con un consulente <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>
      </section>
    </div>
  );
}
